import angular from "angular";

import ServiceProviderVerificationModuleRouting from "./service-provider-verification.module.routing";

export default angular
  .module("vt-service-provider-verification", [])
  .config(ServiceProviderVerificationModuleRouting);
